import { RotateCw } from 'lucide-react';
import { ago } from '../lib/format';

interface Props {
  /** The latest load's failure, from useLoad. Nothing is drawn without one. */
  error: Error | null;
  /** When the rows on screen were read (useLoad's `updatedAt`), if ever. */
  updatedAt: number | null;
  /** What the screen shows, for the sentence: "incidents", "queues". */
  what: string;
  onRetry: () => void;
}

/**
 * What a screen says when a load fails -- above its rows, not instead of them.
 *
 * Every screen used to answer a failed poll by replacing itself with a red
 * line, while useLoad still held the previous answer: one dropped 15s request
 * wiped the incident board somebody was in the middle of reading, and on
 * Queues it closed the drawer they had open. A failure now says what failed,
 * how old the rows below it are, and offers to try again; only a screen that
 * has never loaded at all has nothing to show beneath it.
 */
export function LoadIssue({ error, updatedAt, what, onRetry }: Props) {
  if (!error) return null;
  const since = updatedAt ? new Date(updatedAt).toISOString() : null;
  return (
    <div className={`wt-banner ${since ? 'wt-banner-warn' : 'wt-banner-danger'} wt-load-issue`} role="status">
      <span>
        {since
          ? `Could not refresh ${what}: ${error.message}. Showing what was read ${ago(since)}.`
          : `Could not load ${what}: ${error.message}`}
      </span>
      <button type="button" className="btn btn-secondary" onClick={onRetry}>
        <RotateCw size={13} /> Retry
      </button>
    </div>
  );
}
